<template>
  <div>
    <v-row>
      <v-col cols=12>
        <h3>{{ $translate('Welcome to Zoezi Developer Portal for suppliers') }}</h3>

        <p>{{ $translate('Here you as a supplier can manage addons. Start by clicking Create new addon below and fill in the required information. Then submit the addon for review.') }}</p>

        <p>{{ $translate('Once the addon is reviewed and approved you can follow sales and usage on this page.') }}</p>

        <p>{{ $translate('For more information on how to build an addon') }}, <a :href="apidoclink" target="_blank">{{ $translate('follow this link') }}</a></p>
      </v-col>
    </v-row>

    <v-card>
      <v-card-title>
        <v-btn color="primary" dark class="mb-2" @click="newAddon()">{{ $translate('Create new addon') }}</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-if="addons.length > 5"
          v-model="addon_search"
          append-icon="mdi-magnify"
          :label="$translate('Search')"
          single-line
          hide-details
          @keydown="searchKeyDown"
        ></v-text-field>
      </v-card-title>
      <confirm-remove ref="confirmremove" />
      <v-data-table v-if="addons_for_supplier && addons_for_supplier.length"
        ref="addontable"
        :headers="headers"
        :items="addons_for_supplier"
        class="elevation-1"
        :hide-default-header="$root.isSmallScreen"
        :hide-default-footer="true"
        must-sort
        :items-per-page="1000"
        :search="addon_search"
        @click:row="rowClick"
      >
        <template v-slot:item.image="{ item }">
          <img :src="item.version.image" width="50" height="50" class="mt-2" />
        </template>
        <template v-slot:item.state="{ item }">
          {{getState(item.version.state)}}
        </template>
        <template v-slot:item.version="{ item }">
          {{item.version.version_number}}
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="rowClick(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            v-if="canRemove(item)"
            small
            @click="removeVersion(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {getAddons} from '@/utils.js';

export default {
  name: 'listAddonsComponent',
  data: () => ({
    addons: [],
    addon_search: ''
  }),
  computed: {
    headers() {
      const t = this.$translate;
      this.$root.language; // Reference it
      return [{ text: '', value: 'image', sortable: false},{ text: t('Name'), value: 'name'}, {text: 'ID', value: 'id'}, {text: 'Version', value: 'version'}, {text: 'Status', value: 'state'}, {text: '', value: 'action', sortable: false}];
    },
    addons_for_supplier() {
      return this.addons.filter(x => this.$root.supplier && x.supplier_id == this.$root.supplier.id).sort( (a, b) => a.name.localeCompare(b.name));
    },
    apidoclink() {
      return 'https://' + document.location.hostname + '/apidoc/#addons';
    }
  },
  mounted() {
    this.updateAddons();
  },
  methods: {
    updateAddons() {
       getAddons().then(data => {
          this.addons = data;
       });
    },
    rowClick(addon) {
      if (this.$refs.confirmremove.showDialog) {
        return;
      }
      this.$router.push({name: 'show', params: {addon_id: addon.id}});
    },
    getState(state) {
      switch (state) {
        case 'test': return this.$translate('In development');
        case 'review': return this.$translate('Under review');
        case 'live': return this.$translate('Published');
      }
    },
    newAddon() {
      let data = {name: this.$translate('New addon'), supplier_id: this.$root.supplier.id};
      fetch('/api/addon/supplier/add', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)}).then(response => {
        if (response.status == 200) {
          response.json().then(addon => this.$router.push('/show/' + addon.id))
        } else if (response.status == 401) {
          this.$root.onLoggedOut();
        } else {
          this.$root.showErrorDialog(this.$translate('Error'), this.$translate('Could not add new addon'));
        }
      });
    },
    searchKeyDown(e) {
      if (e.keyCode == 13 && this.$refs.addontable.selectableItems.length == 1) {
        this.rowClick(this.$refs.addontable.selectableItems[0]);
      }
    },
    canRemove(addon) {
      return addon.version.state == 'test';
    },
    removeVersion(addon) {
      this.$refs.confirmremove.show(this.$translate('Do you really want to remove the development version of the addon?')).then(() => {
        let data = {id: addon.version.id};
        fetch('/api/addon/supplier/version/remove', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)}).then(() => {
          this.updateAddons();
        });
      });
    }
  }
};
</script>
